const USER_DATA_KEY = 'selfGuidedSession';

export function getStoredUserData() {
  const userData = localStorage.getItem(USER_DATA_KEY);
  if (!userData) {
    return {};
  }
  try {
    return JSON.parse(userData);
  } catch {
    // If JSON parsing fails, clear the invalid data from localStorage
    localStorage.removeItem(USER_DATA_KEY);
    // return an empty object
    return {};
  }
}

export function storeUserData(user) {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));
}
